






































import useDispatchProcess from '@/hooks/useDispatchProcess';
import { defineComponent, computed, PropType } from '@vue/composition-api';
import { ubtSendError } from '@/shared/utils/ubt';
import { dispatchActions } from '@/store/dispatchActions';
import store from '@/store';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { TP_HOME_GO_CREDIT_CLICK } from '@/pages/home/tianqi';
import { RightArrowOutline12 } from '@hb/coffee-icons';

export default defineComponent({
  name: 'IncreaseCreditBar',
  props: {
    ubtCommonParams: {
      type: Object as PropType<Record<string, unknown>>,
      required: true,
    },
    isMiddleIncomeShow: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    RightArrowOutline12,
  },
  setup(props) {
    /** 授信流程分发 */
    const { creditProcessDispatch } = useDispatchProcess();
    /** “去查看”按钮文案 */
    const applybuttonText = computed(() => {
      const { tempAmountStatus, tempTimeout } = store.state.tempAmount;
      /** 若点击“申请提额”按钮触发 临额申请中，则展示“提额中 x秒”等待临额下发 */
      return (tempAmountStatus?.tempAmountApplying && tempTimeout) ? `提额中 ${tempTimeout}s` : '去查看';
    });

    const onClickIncreaseCredit = async () => {
      try {
        /** “去提额”点击埋点 */
        ubtSetupPageButton(TP_HOME_GO_CREDIT_CLICK, props.ubtCommonParams);

        if (await dispatchActions.tempAmount.creditApplyTempAmount()) {
          creditProcessDispatch();
        }
      } catch (error) {
        ubtSendError(error as Error);
        creditProcessDispatch();
      }
    };

    return {
      applybuttonText,
      RightArrowOutline12,
      onClickIncreaseCredit,
    };
  },
});
